Vue.component('confirmModal', {
    template: templates.confirmModal,
    data() {
      return {
        model: {
            card: [],
            cards: [],
            bone: [],
            delta: [],
            ascension: [],
            message: '',
            dumpCards: {},
            store: {},
            inventory: {},
            value: '',
            status: '',
            season: {
              name: null,
              description: null,
              startDate: null,
              startTime: null,
              endSeason: null,
              active: false,
            },
            startSeason: false,
            seasonControls: false,
            seasonPause: null,
            userSubscriptionData: {},
            exaltedChamber: null,
            deltaInfo: null,
            confirmUnequip: false,

        }
      }
    },
    computed: {
      equippedDeltaCard() {
        const delta = this.model.deltaInfo;
        if (!delta) return null;
        return {
          id: delta.id,
          name: delta.deltaCard,
          description: delta.deltaCardDescription,
          effect: delta.deltaCardEffect,
          image: `${root}/images/delta-cards/${delta.deltaCardKey}.png`,
          tier: 10,
          owned: true,
        };
      }
    },
    mounted() {
      const c = this;

      c.$root.$on('startEndSeason', data => {
        c.model.message = data.message
        c.model.startSeason = data.status
        c.model.seasonControls = true,
        c.model.seasonPause = data.isPaused
        c.model.season = data.season

      })

      c.$root.$on('boneCardAccept', data => {
        c.model.card.push(data.card)
        c.model.bone.push(data.bone)
        c.model.message = data.message
      })

      c.$root.$on('deltaCardAccept', data => {
        c.model.card.push(data.card)
        c.model.delta.push(data.delta)
        c.model.message = data.message
      })

      c.$root.$on('ascensionChamber', data => {
        c.model.message = data.message
        c.model.cards = data.cards
        c.model.ascension = data.ascension
      })

      c.$root.$on('chamberUpgrade', data => {
        c.model.message = data.message
        c.model.inventory = data.inventory
        c.model.dumpCards = data.dumpCards
      })

      c.$root.$on('SpiritForgeConfirm', data => {
        c.model.message = data.message
        c.model.card = data.card
        c.model.value = data.value
      })

      c.$root.$on('selectStreamerTeam', data => {
    
      })

      c.$root.$on('confirmUpdateSubscription', data => {
        c.model.message = data.message
        c.model.userSubscriptionData = data
      })

      c.$root.$on('cancelSubscription', data => {
        c.model.message = data.message
        c.model.status = data.status
      })

      c.$root.$on('reactivateSubscription', data => {
        c.model.message = data.message
        c.model.status = data.status
      })

      c.$root.$on('exaltedChamberConfirm', data => {
        c.model.message = data.message
        c.model.exaltedChamber = data
      })

      c.$root.$on('showDeltaInfo', data => {
        c.model.deltaInfo = data.card;
        $('.modal').addClass('is-above').addClass('is-visible');
        c.$nextTick(() => {
          $('.delta-preview .bottom').removeClass('is-hidden');
        });
      })

    },
    beforeDestroy() {
      const c = this;
      c.$root.$off('startEndSeason');
      c.$root.$off('boneCardAccept');
      c.$root.$off('deltaCardAccept');
      c.$root.$off('showDeltaInfo');
      c.$root.$off('ascensionChamber');
      c.$root.$off('chamberUpgrade');
      c.$root.$off('SpiritForgeConfirm');
      c.$root.$off('selectStreamerTeam');
      c.$root.$off('confirmUpdateSubscription');
      c.$root.$off('cancelSubscription');
      c.$root.$off('subscriptionCancelled');
      c.$root.$off('exaltedChamberConfirm');
    },
    methods: {
        confirm() {
            const c = this;
            if(c.model.deltaInfo && c.model.confirmUnequip){
              c.$root.$emit('confirmUnequipDelta', { card: c.model.deltaInfo });
              c.reset();
            }
            if(c.model.delta.length > 0){
              c.$root.$emit('confirmDeltaEquip', {card: c.model.card[0], delta: c.model.delta[0]})
              c.reset()
            }
            if(c.model.bone.length > 0){
              c.$root.$emit('confirmBoneEquip', {card: c.model.card[0], bone: c.model.bone[0]})
              c.reset()
            }
            if(c.model.dumpCards.length > 0){
              c.$root.$emit('confirmDump', {inventory: c.model.inventory , dumpCards: c.model.dumpCards})
              c.reset()
            }
            if(c.model.cards.length > 0 && c.model.ascension.length > 0){
              c.$root.$emit('confirmCardUpgrade')
              c.reset()
            }
            if(c.model.value){
              c.$root.$emit('confirmSpiritForge', {value: c.model.value, card: c.model.card})
              c.reset()
            }
            if(c.model.startSeason || c.model.seasonControls){
              c.seasonSave(c.model.startSeason);
              c.$root.$emit('seasonStartEnd', {value: c.model.startSeason})
              c.model.seasonControls = false;
            }

            if(Object.keys(c.model.userSubscriptionData).length > 0){
              if(!c.model.userSubscriptionData.cancel){
                c.saveUserSubscription();
              }
              else{
                c.cancelUserSubscription();
              }
            }

            if(c.model.status === 'cancel_subscription'){
              c.$root.$emit('subscriptionCancelled');
              c.reset()
            }

            if(c.model.status === 'reactivate_subscription'){
              c.$root.$emit('subscriptionReactivated');
              c.reset()
            }

            if(c.model.exaltedChamber){
              c.exaltCard(c.model.exaltedChamber);
              c.reset()
            }


            $('.modal').removeClass('is-above').removeClass('is-visible');
        },
        cancel(){
            const c = this;
            c.reset()
            $('.modal').removeClass('is-above').removeClass('is-visible');
            
        },
        reset() {
          const c = this;

          c.model.card = [];
          c.model.bone = [];
          c.model.delta = [];
          c.model.deltaInfo = null;
          c.model.confirmUnequip = false;
          c.model.ascension = [];
          c.model.message = '';
          c.model.dumpCards = {};
          c.model.store = {};
          c.model.inventory = {};
          c.model.value = null;
          c.model.seasonPause = null;
          c.model.userSubscriptionData = {};
          c.model.status = '';
          c.model.exaltedChamber = null;
        },
        exaltCard(data) {
          const c = this;

          const payload = {
            twitchId: utils.cookies.get('user_id'),
            mainCardNumber: data.mainCard.cardNumber,
            sacrificeCardNumbers: data.sacrifices.map(s => s.cardNumber)
          };

          userService.exaltCard(payload)
            .then(function () {
              utils.alert.success(`${data.mainCard.name} has been Exalted!`);

              if (data.item_cooldown > 0) {
                return userService.userStoreActive({
                  type: 'Inventory',
                  id: data.inventoryId,
                  item_cooldown: data.item_cooldown,
                  active: true
                });
              }
            })
            .then(function () {
              c.$root.$emit('confirmExaltedChamber', { mainCard: data.mainCard });
            })
            .catch(function () {
              utils.alert.error('Failed to exalt card.');
            });
        },
        seasonSave(startSeason){
          const c = this;
          let data = c.model.season;

          data.status = startSeason;
          data.isPuased = c.model.isPausedl
  
          seasonService.save(data)
            .then(function (response) {
              
            })
            .catch(function (error) {
              utils.alert.error('Failed to save.');
            });
        },
        saveUserSubscription(){
          const c = this;

          let data = c.model.userSubscriptionData.userData;

          subscriptionService.updateUserSubscription(data).then(function(response) {

            c.$root.$emit('updateUserSubscription', {value: data})
            
           setTimeout(function(){
            c.model.userSubscriptionData = {};
           }, 1000)
          
          })
          .catch(function(error) {
              console.log(error);
          });
        },
        cancelUserSubscription(){

          const c = this;

          let data = c.model.userSubscriptionData.userData;
          
          subscriptionService.cancelSubscription(data).then(function(response){
            c.$root.$emit('updateUserSubscription', {value: data})
            setTimeout(function(){
              c.model.userSubscriptionData = {};
             }, 1000)
          })
          .catch(function(error){
            console.log(error)
          })

        }
    }
  });